export default __webpack_public_path__ + "static/media/sectores_9.2a23c93c.png";